import { render, staticRenderFns } from "./Bomb.vue?vue&type=template&id=236a65da&scoped=true&"
import script from "./Bomb.vue?vue&type=script&lang=js&"
export * from "./Bomb.vue?vue&type=script&lang=js&"
import style0 from "./Bomb.vue?vue&type=style&index=0&id=236a65da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a65da",
  null
  
)

export default component.exports